import { DataService } from '../dataService';

const authorChapterServices = {
  createChapterApi: (data) => {
    return DataService.post('author/chapter', data);
  },
  updateChapterApi: (id, data) => {
    return DataService.put(`author/chapter/${id}`, data);
  },
  deleteChapterApi: (id, data) => {
    return DataService.delete(`author/chapter/${id}`, data);
  },
  uploadZipHander: (data) => {
    return DataService.post(`book/zip-file`, data);
  },
  uploadImageAPIzip: (data) => {
    return DataService.get(`book/sync-images?book_id=${data?.book_id}`);
  },

  // api for breadcrumb 

  getChapterSlug: (id) => {
    return DataService.get(`static/slug/chapters/${id}`);
  },
  getHeaderOneSlug: (id) => {
    return DataService.get(`static/slug/header-1/${id}`);
  },
  getHeaderTwoSlug: (id) => {
    return DataService.get(`static/slug/header-2/${id}`);
  },
  getHeaderThreeSlug: (id) => {
    return DataService.get(`static/slug/header-3/${id}`);
  },


};

export default authorChapterServices;
